import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDashboardInfo(params) {
	return client.get("binary/dashboard/information-member", {
		params: params,
	});
}

function getLeftover(params) {
	return client.get("dashboard/transaction/leftover", {
		params: params,
	});
}

function getSerialCount(params) {
	return client.get("dashboard/serial-count", {
		params: params
	});
}

function getGrowthSummary(params) {
	return client.get("dashboard/member-grow-per-week", {
		params: params,
	});
}

function getTotalMember(params) {
	return client.get("dashboard/total-member", {
		params: params,
	});
}

function getTransactionSummary(params) {
	return client.get("dashboard/member-transaction-summary", {
		params: params,
	});
}

function getBonusPotency(params) {
	return client.get("unilevel/bonus/potency", {
		params: params,
	});
}

function getReferral(params) {
	return client.get("dashboard/referral", {
		params: params,
	});
}

export default {
	getDashboardInfo,
	getLeftover,
	getSerialCount,
	getTotalMember,
	getGrowthSummary,
	getTransactionSummary,
	getBonusPotency,
	getReferral,
};